import React from 'react';
import { FiFileText, FiCheck } from 'react-icons/fi';

const TemplateSelector = ({ templates, selectedTemplate, onSelectTemplate }) => {
  const templateCategories = {
    marketing: { name: 'Marketing', color: 'bg-pink-100 text-pink-700' },
    newsletter: { name: 'Newsletter', color: 'bg-blue-100 text-blue-700' },
    whitepaper: { name: 'Whitepaper', color: 'bg-green-100 text-green-700' },
    partnership: { name: 'Partnership', color: 'bg-indigo-100 text-indigo-700' }
  };

  return (
    <div className="bg-neutral-50 rounded-xl p-6 h-fit border border-neutral-200 shadow-soft">
      <h2 className="text-lg font-bold text-neutral-900 mb-4 flex items-center gap-2">
        <div className="w-8 h-8 bg-gradient-to-br from-accent-500 to-accent-600 rounded-lg flex items-center justify-center">
          <FiFileText className="w-4 h-4 text-white" />
        </div>
        Email Templates
      </h2>
      <div className="space-y-2">
        {templates.length === 0 ? (
          <div className="text-center py-8">
            <div className="animate-pulse text-neutral-400 text-sm">Loading templates...</div>
          </div>
        ) : (
          templates.map((template) => {
            const category = templateCategories[template.category] || {
              name: template.category,
              color: 'bg-neutral-100 text-neutral-700'
            };
            const isSelected = selectedTemplate?.id === template.id;

            return (
              <button
                key={template.id}
                onClick={() => onSelectTemplate(template)}
                className={`w-full text-left p-4 rounded-lg border transition-all duration-200 ${
                  isSelected
                    ? 'border-primary-500 bg-primary-50 shadow-medium'
                    : 'border-neutral-200 bg-white hover:border-primary-300 hover:shadow-soft'
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <h3 className="font-semibold text-neutral-900">{template.name}</h3>
                      {isSelected && (
                        <div className="w-5 h-5 bg-primary-600 rounded-full flex items-center justify-center">
                          <FiCheck className="text-white w-3 h-3" />
                        </div>
                      )}
                    </div>
                    <span className={`inline-block px-2.5 py-1 rounded-md text-xs font-semibold ${category.color}`}>
                      {category.name}
                    </span>
                  </div>
                </div>
              </button>
            );
          })
        )}
      </div>
      <div className="mt-6 p-4 bg-primary-50 border border-primary-200 rounded-lg">
        <p className="text-xs text-primary-800 leading-relaxed">
          <strong className="font-semibold">💡 Tip:</strong> Select a template to get started, then customize it to your needs. Templates support dynamic placeholders like {'{{recipientName}}'}.
        </p>
      </div>
    </div>
  );
};

export default TemplateSelector;
